import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";

export default function NoPermission() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        textAlign: "center",
        padding: 20,
      }}
    >
      <FontAwesomeIcon icon={faLock} style={{ fontSize: 48, color: "#999" }} />
      <h5 style={{ marginTop: 20, fontWeight: "bold" }}>
        ທ່ານບໍ່ມີສິດເຂົ້າເຖິງໜ້ານີ້
      </h5>
      <div style={{ color: "#777" }}>
        ກະລຸນາຕິດຕໍ່ເຈົ້າຂອງຮ້ານ ເພື່ອກຳນົດສິດໃຫ້ບັນຊີຂອງທ່ານ
      </div>
    </div>
  );
}
